import { render, staticRenderFns } from "./Loginstart.vue?vue&type=template&id=c6cb650c&scoped=true"
import script from "./Loginstart.vue?vue&type=script&lang=js"
export * from "./Loginstart.vue?vue&type=script&lang=js"
import style0 from "./Loginstart.vue?vue&type=style&index=0&id=c6cb650c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cb650c",
  null
  
)

export default component.exports